import Rows from "../../../library/components/layout/Rows";
import GenelDurumHelper, { GenelDurumLoginStateHelper } from "../../../helpers/GenelDurumHelper";
import Columns from "../../../library/components/layout/Columns";
import { CsmText } from "../../../library/components/mui/CsmText";
import { CalismaModel } from "../../../models/businessModels/CalismaModel";
import DateTimeHelper from "../../../library/helpers/DateTimeHelper";
import DateTimeToStringHelper from "../../../library/helpers/DateTimeToStringHelper";
import { alpha, Button } from "@mui/material";
import { appIcons } from "../../../app/appIcons";
import { BusinessHelper } from "../../../helpers/BusinessHelper";
import appColors from "../../../app/appColors";
import { CSSProperties } from "react";
import { EnmYetki } from "../../../models/enums/EnmYetki";
import YoklamaBildirmePopupEditor from "../takvim/YoklamaBildirmePopupEditor";
import AlertHelper from "../../../library/helpers/AlertHelper";
import { HesapCalismaModel } from "../../../models/businessModels/HesapCalismaModel";
import { CsmHeader } from "../../../library/components/mui/CsmHeader";
import { SarkiModel } from "../../../models/businessModels/SarkiModel";


interface IGuncelCalismaDisplayerProps {
    genelDurumHelper: GenelDurumHelper,
}

function GuncelCalismaDisplayer(props: IGuncelCalismaDisplayerProps) {
    const { genelDurumHelper } = props;

    const aktifKoro = genelDurumHelper.SeciliKoroModel;

    const yoklamaArabirimiKullanilsin = aktifKoro.koroAyarlari.yoklamaArabirimiKullanilsin;

    const yeniCalismalar = aktifKoro.tumCalismalar.where(e => DateTimeHelper.getDateWithoutTime(e.tarihBaslangic) >= DateTimeHelper.today());
    const yukumluCalismaIdler = BusinessHelper.Calisma.KisiyeUygunCalismalariGetir(yeniCalismalar, genelDurumHelper.SeciliHesapBilgiModel, aktifKoro.hesapCalismaModelList, false, aktifKoro.tumSesGruplari).select(e => e.id);

    const groupedCalismalar = groupedCalismaListOlustur(genelDurumHelper);

    async function katilimDurumBildir(calisma: CalismaModel, hesapCalisma: HesapCalismaModel | null) {
        const response = await AlertHelper.ShowClosableContent<HesapCalismaModel>(`Yoklama Durum Bildir`, (closer) =>
            <YoklamaBildirmePopupEditor
                closer={closer}
                caslima={calisma}
                genelDurumHelper={genelDurumHelper}
                orijinalHesapCalisma={hesapCalisma}
            />
        );

        if (response == null)
            return;

        GenelDurumLoginStateHelper.GenelDurumStateGuncelle(genelDurumHelper.dispatch, genelDurumHelper.genelDurum,
            (newGenelDurum) => {
                const seciliKoro = BusinessHelper.Genel.SeciliKoroGetir(newGenelDurum, genelDurumHelper.user)!;
                const seciliHesap = seciliKoro.hesapBilgiModel;
                const hesapCalismaList = seciliKoro.hesapCalismaModelList;
                const itemToRemove = hesapCalismaList.singleOrDefault(e => e.calismaModelId === calisma.id && e.hesapModelId === seciliHesap.id);

                if (itemToRemove)
                    hesapCalismaList.remove(itemToRemove);
                hesapCalismaList.push(response!);
            });
    }

    function renderCalismaList(calismaList: CalismaModel[]): JSX.Element[] | null {
        if (calismaList.length === 0)
            return null;

        return calismaList.map((calisma) => {
            const hedefKitle = BusinessHelper.Genel.HedefKitleTextGetir(calisma.kadroIdList, calisma.sesGrupIdList, aktifKoro.tumKadrolar, aktifKoro.tumSesGruplari);

            const hedefKitleMi = yukumluCalismaIdler.contains(calisma.id);
            const hedefKitleStyle: CSSProperties = hedefKitleMi ? { color: appColors.TEXT_SECONDARY } : {};

            const hesapCalismaModel = aktifKoro.hesapCalismaModelList.singleOrDefault(e => e.hesapModelId === genelDurumHelper.SeciliHesapBilgiModel.id && e.calismaModelId === calisma.id);

            // hedef kitleyse ve okumamışsa, doldurmak zorunda
            const doldurmali = (calisma.tarihBitis > DateTimeHelper.today()) && hedefKitleMi && (hesapCalismaModel == null || hesapCalismaModel.katilimDurum == null);
            const katilimRenkYazi = BusinessHelper.Calisma.KatilimDurumRenkYaziGetir(calisma, aktifKoro.hesapCalismaModelList, genelDurumHelper.SeciliHesapBilgiModel, yoklamaArabirimiKullanilsin, aktifKoro.tumSesGruplari);
            //zorunlu değilse katılım satırı olmasın ve bildirim yapılmamışsa
            //zorunlu ise özel renklensin

            return (
                <Columns hasLightBottomBorder key={calisma.id} width={390} mb={5}>
                    <div style={{ display: "flex", placeContent: "center", width: "40px" }}>
                        {appIcons.Genel.takvimPrimary}
                    </div>
                    <Rows flex>
                        <CsmText>{DateTimeToStringHelper.toMonthDayAndDayOfWeekString(calisma.tarihBaslangic, genelDurumHelper.translate)} {DateTimeToStringHelper.toTimeString(calisma.tarihBaslangic)} - {DateTimeToStringHelper.toTimeString(calisma.tarihBitis)}</CsmText>
                        <CsmText style={{ ...hedefKitleStyle }} note>{genelDurumHelper.translate("Hedef Kitle")}: {hedefKitle}</CsmText>
                        <CsmText note>{genelDurumHelper.translate("İçerik")}: {calisma.icerik}</CsmText>
                        {(doldurmali || hesapCalismaModel) ?
                            <div style={{ marginLeft: "-10px" }} >
                                <Button fullWidth onClick={() => katilimDurumBildir(calisma, hesapCalismaModel)}>
                                    <CsmText style={{ width: "100%", textTransform: "none", color: appColors.BACKGROUND, paddingLeft: "15px", paddingRight: "15px", borderRadius: "5px", background: katilimRenkYazi.renk ? alpha(katilimRenkYazi.renk!, 0.7) : undefined }} note>{katilimRenkYazi.yazi}</CsmText>
                                </Button></div>
                            : null}
                    </Rows>
                </Columns>
            );
        });
    }

    function renderKayitBekleyenSarkiList(sarkiList: { sarki: SarkiModel; tarih: Date; }[]) {
        if (sarkiList.length === 0)
            return null;

        const tumDoluGunler = sarkiList.select(e => DateTimeHelper.getDateWithoutTime(e.tarih)).select(e => e.valueOf()).distinct().orderBy(e => e).select(e => new Date(e));

        return (
            <Rows mt={5} flex>
                <CsmText note bold italic>Kayıt Tarihi Yaklaşan Eserler:</CsmText>
                {tumDoluGunler.map(gun => {
                    const gununSarkilari = sarkiList.where(e => DateTimeHelper.isSameDate(e.tarih, gun));

                    const gununSarkilariContent = gununSarkilari.map(sarki => (
                        <li key={sarki.sarki.id}>
                            <CsmText note>{sarki.sarki.isim}</CsmText>
                        </li>
                    ))

                    return (
                        <Rows mt={5} key={gun.toString()}>
                            <CsmText note>{DateTimeToStringHelper.toMonthDayAndDayOfWeekString(gun, genelDurumHelper.translate)}</CsmText>
                            <ul style={{ marginTop: 0, marginBottom: 0 }}>
                                {gununSarkilariContent}
                            </ul>
                        </Rows>
                    )
                })}
            </Rows>
        );
    }

    return <Rows flex mt={10}>
        {aktifKoro.koroAyarlari.etkinlikTakivimiKullanilsin ?
            <CsmHeader pl={15} hasVeryLightBottomBorder>{genelDurumHelper.translate("Çalışma Tarihleri")}</CsmHeader>
            :
            <CsmHeader pl={15} hasVeryLightBottomBorder>{genelDurumHelper.translate("Yaklaşan Çalışmalar")}</CsmHeader>
        }
        {groupedCalismalar.map((item, i) => ((item.calismaList.length === 0 && item.sarkiList.length === 0) && item.showEmpty === false) ? null : (
            <Rows key={i} ml={15} mt={15}>
                <CsmText bold style={{ marginBottom: "5px" }}>{item.title}</CsmText>
                <Columns wrap>
                    {renderCalismaList(item.calismaList) ?? <CsmText note>{genelDurumHelper.translate("Çalışma bulunmamaktadır")}</CsmText>}
                </Columns>
                {renderKayitBekleyenSarkiList(item.sarkiList)}
            </Rows>
        ))}
    </Rows>
}

export default GuncelCalismaDisplayer;

function groupedCalismaListOlustur(genelDurumHelper: GenelDurumHelper): {
    sarkiList: { sarki: SarkiModel, tarih: Date }[],
    calismaList: CalismaModel[],
    title: string,
    showEmpty?: boolean
}[] {

    const aktifKoro = genelDurumHelper.SeciliKoroModel;
    const etkinlikTakvimi = aktifKoro.koroAyarlari.etkinlikTakivimiKullanilsin;

    const calismaYetki = genelDurumHelper.HasYetkiAny([EnmYetki["Calışma Yönetim"], EnmYetki["Calışma İzleme"]]);

    const yeniCalismalar = aktifKoro.tumCalismalar.where(e => DateTimeHelper.getDateWithoutTime(e.tarihBaslangic) >= DateTimeHelper.today());
    const sezonCalismalari = aktifKoro.tumCalismalar.where(e => e.sezonModelId === aktifKoro.sezonModelId);
    const calismalar = etkinlikTakvimi ? sezonCalismalari : yeniCalismalar;

    const gosterilecekCalismalar = BusinessHelper.Calisma.KisiyeUygunCalismalariGetir(calismalar, genelDurumHelper.SeciliHesapBilgiModel, aktifKoro.hesapCalismaModelList, calismaYetki || !aktifKoro.koroAyarlari.koristlerSadeceSorumluCalismalariGorebilir, aktifKoro.tumSesGruplari).orderBy(e => e.tarihBaslangic);
    const sonKayitTarihliSarkilar = genelDurumHelper.SeciliKoroModel.tumSarkilar.selectMany(e => e.sezonSarkiModelList.select(t => ({ sarki: e, sezonId: t.sezonModelId, tarih: t.kayitTarihi }))).where(e => e.tarih !== null);

    const tarihler = calismaGrupTarihleriniGetir(gosterilecekCalismalar, etkinlikTakvimi, genelDurumHelper);

    const buHaftaCalismalar = etkinlikTakvimi ? [] : buHaftaCalismaVeriOlustur(gosterilecekCalismalar, sonKayitTarihliSarkilar, genelDurumHelper)

    return [
        ...buHaftaCalismalar,
        ...tarihler.map(tarihBilgi => ({
            calismaList: gosterilecekCalismalar.where(e => e.tarihBaslangic >= tarihBilgi.bas && (tarihBilgi.bitis === null || e.tarihBitis < tarihBilgi.bitis)),
            sarkiList: sonKayitTarihliSarkilar.where(e => e.tarih! >= tarihBilgi.bas && (tarihBilgi.bitis === null || e.tarih! < tarihBilgi.bitis)).select(e => ({ sarki: e.sarki, tarih: e.tarih! })),
            title: tarihBilgi.title
        }))
    ];
}

function calismaGrupTarihleriniGetir(gosterilecekCalismalar: CalismaModel[], etkinlikTakvimi: boolean, genelDurumHelper: GenelDurumHelper) {
    if (etkinlikTakvimi) {
        const aybaslari = !etkinlikTakvimi ? [] : gosterilecekCalismalar.select(e => DateTimeHelper.getFirstOfMonth(e.tarihBaslangic).valueOf()).distinct().select(e => new Date(e));
        return aybaslari.map((e, i) => ({
            bas: e,
            bitis: i === aybaslari.length - 1 ? null : aybaslari[i + 1],
            title: `${DateTimeToStringHelper.toMonthAndYearString(e, genelDurumHelper.translate)}`
        }));
    }
    else {
        const pazartesi1 = DateTimeHelper.getMondayOfWeek(DateTimeHelper.today());
        const pazartesi2 = DateTimeHelper.addDays(pazartesi1, 7);
        const pazartesi3 = DateTimeHelper.addDays(pazartesi2, 7);
        const ay1 = DateTimeHelper.addMonth(pazartesi3, 1);
        const ay2 = DateTimeHelper.addMonth(ay1, 1);
        const ay3 = DateTimeHelper.addMonth(ay2, 1);
        const ay4 = DateTimeHelper.addMonth(ay3, 1);

        return [
            { bas: pazartesi2, bitis: pazartesi3, title: genelDurumHelper.translate("Sonraki Hafta Haftası", { hafta: DateTimeToStringHelper.toMonthDayStringOptionalYear(pazartesi2, genelDurumHelper.translate) }) },
            { bas: pazartesi3, bitis: ay1, title: genelDurumHelper.translate("Diğer Haftalar Haftası ve Sonrası", { hafta: DateTimeToStringHelper.toMonthDayStringOptionalYear(pazartesi3, genelDurumHelper.translate) }) },
            { bas: ay1, bitis: ay2, title: `${DateTimeToStringHelper.toMonthAndYearString(ay1, genelDurumHelper.translate)}` },
            { bas: ay2, bitis: ay3, title: `${DateTimeToStringHelper.toMonthAndYearString(ay2, genelDurumHelper.translate)}` },
            { bas: ay3, bitis: ay4, title: `${DateTimeToStringHelper.toMonthAndYearString(ay3, genelDurumHelper.translate)}` },
            { bas: ay4, bitis: null, title: genelDurumHelper.translate("TARIH ve sonrası", { tarih: DateTimeToStringHelper.toMonthAndYearString(ay4, genelDurumHelper.translate) }) },
        ]
    }
}

function buHaftaCalismaVeriOlustur(gosterilecekCalismalar: CalismaModel[], sonKayitTarihliSarkilar: { sarki: SarkiModel; sezonId: string; tarih: Date | null; }[], genelDurumHelper: GenelDurumHelper): {
    sarkiList: { sarki: SarkiModel, tarih: Date }[],
    calismaList: CalismaModel[],
    title: string,
    showEmpty?: boolean
}[] {
    const pazartesi1 = DateTimeHelper.getMondayOfWeek(DateTimeHelper.today());
    const pazartesi2 = DateTimeHelper.addDays(pazartesi1, 7);

    const buHaftaCalismalarData = gosterilecekCalismalar.where(e => e.tarihBaslangic >= pazartesi1 && e.tarihBitis < pazartesi2);
    const buHaftaSarkilarData = sonKayitTarihliSarkilar.where(e => e.tarih! >= pazartesi1 && e.tarih! < pazartesi2).select(e => ({ sarki: e.sarki, tarih: e.tarih! }));

    return buHaftaCalismalarData.length <= 4 ? [
        {
            sarkiList: buHaftaSarkilarData,
            calismaList: buHaftaCalismalarData,
            title: genelDurumHelper.translate("Bu Hafta"), showEmpty: true
        },
    ] : Array.from(Array(7).keys()).map(additionDays => {
        const currentDay = DateTimeHelper.addDays(pazartesi1, additionDays);
        const nextDay = DateTimeHelper.addDays(pazartesi1, additionDays + 1);
        const relatedCalismalar = buHaftaCalismalarData.where(e => e.tarihBaslangic >= currentDay && e.tarihBitis < nextDay);
        const relatedSarkilar = buHaftaSarkilarData.where(e => e.tarih >= currentDay && e.tarih < nextDay);

        return {
            sarkiList: relatedSarkilar,
            calismaList: relatedCalismalar,
            title: DateTimeToStringHelper.toMonthDayAndDayOfWeekStringWithoutYear(currentDay, genelDurumHelper.translate), showEmpty: true
        };
    });
}